export interface KpiSettings {
    perf1: string;
    perf2: string;
    perf3: string;
    perf4: string;
}

export const emptyKpiSettings: KpiSettings = {
    perf1: '',
    perf2: '',
    perf3: '',
    perf4: ''
}
